'use client'



//page
import Nav from './Nav';
const posts = [
    {
        id: 1,
        title: 'Un colloque international et interdisciplinaire',
        href: 'https://passagesxx-xxi.univ-lyon2.fr/activites/archives-des-manifestations/colloque-repair-violences-sexuelles-changer-les-representations-repenser-les-prises-en-charge',
        description:
            'Un colloque interdisciplinaire et international du 3 au 5 mars 2022',
        date: '3-5 mars 2022',
        category: { title: 'Colloque', href: '#' },
    },
    {
        id: 2,
        title: 'Une publication collective dirigée par Bérénice Hamidi et Gaëlle Marti (dir.)',
        href: '#',
        description: 'Faire Face aux violences sexistes et sexuelles. Changer les représentations, repenser les prises en charge, Presses Universitaires de Vincennes, 2026',
        date: '2026',
        category: { title: 'Publication', href: '#' },
    },

]

const projects = [
    {
        id: 1,
        name: 'Bérénice Hamidi, Le viol, notre culture',
        href: '#',
        status: 'Livre',
        createdBy: ' Editions du Croquant',
        dueDate: '2025',
    },
    {
        id: 2,
        name: 'Stéphanie Hennette-Vauchez, Marc Pichard, Diane Roman (dir.), La Loi et le genre',
        href: '#',
        status: 'Livre',
        createdBy: 'CNRS Editions',
        dueDate: '2014',
    },
    {
        id: 3,
        name: 'Catherine Le Magueresse, Les Pièges du consentement',
        href: '#',
        status: 'Livre',
        createdBy: 'Editions IXe',
        dueDate: '2021',
    },
    {
        id: 4,
        name: 'Hélène Merlin-Kajman, La Littérature à l\'heure de Metoo',
        href: '#',
        status: 'Livre',
        createdBy: 'Ithaque',
        dueDate: '2020',
    },
    {
        id: 5,
        name: 'Laure Murat, Toutes les époques sont dégueulasses',
        href: '#',
        status: 'Livre',
        createdBy: ' Verdier',
        dueDate: '2025',
    },
]

const projects2 = [
    {
        id: 1,
        name: 'Sarah Delale, Elodie Pinel, Marie-Pierre Tachet, Pour en finir avec la passion.L\'abus en littérature.',
        href: '#',
        status: 'Livre',
        createdBy: 'Amsterdam, 2023',
        dueDate: '2023',
    },
    {
        id: 2,
        name: 'Azélie Fayolle, Des Femmes et du style. Pour un feminist gaze,',
        href: '#',
        status: 'Livre',
        createdBy: 'Divergences',
        dueDate: '2023',
    },
    {
        id: 3,
        name: 'Manon Garcia, Vivre avec les hommes. Réflexions sur le procès Pélicot',
        href: '#',
        status: 'Livre',
        createdBy: 'Climats',
        dueDate: '2025',
    },
    {
        id: 4,
        name: 'Jennifer Tamas, Au non des femmes,',
        href: '#',
        status: 'Livre',
        createdBy: 'Seuil',
        dueDate: '2023',
    },
]

export default function Calendrier() {

    return (
        <>
            <div className="bg-[url('img/back-proces.png')] bg-top bg-cover">
                <Nav />

                <div className="relative isolate px-6 pt-14 lg:px-8">

                    <div className="mx-auto max-w-7xl py-32">
                        <div className="text-left">
                            <h1 className="text-balance text-[80px] leading-[5.5rem] font-semibold tracking-tight text-white  max-w-[80%] ">
                                En savoir plus
                            </h1>

                            <div className='mt-10 w-full'>

                                <div className="mt-10  border-t border-gray-200 pt-10 sm:mt-16 sm:pt-16">
                                    <p className='text-white text-[22px] leading-[2rem] font-medium'>
                                        «Notre procès» s’inscrit dans le cadre d’un programme de recherche pluriannuel sur les violences sexistes et sexuelles : le projet REPAIR, porté par Bérénice Hamidi et Gaëlle Marti.
                                        <br /><br />
                                        <a href="https://25images.msh-lse.fr/podcasts-appel-projets-msh/video/projet-repair/" target="blank" className="rounded-full bg-indigo-800 px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Découvrir le projet</a>
                                    </p>
                                    
                                    <div className="mx-auto max-w-7xl mt-16">
                                        <div className="mx-auto max-w-2xl lg:mx-0">
                                            <h2 className='text-white text-xl'>
                                                Il a donné lieu à :
                                            </h2>
                                        </div>
                                        <div className="mx-auto mt-4 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16  lg:mx-0 lg:max-w-none lg:grid-cols-2 dark:border-gray-700">
                                            {posts.map((post) => (
                                                <article key={post.id} className="flex max-w-xl flex-col items-start justify-between  bg-[#ffffff26] border-rounded-3xl p-8 shadow-xl">
                                                    <div className="flex items-center gap-x-4 text-sm">
                                                        <time dateTime={post.datetime} className="text-white dark:text-gray-400">
                                                            {post.date}
                                                        </time>
                                                        <a
                                                            href={post.category.href}
                                                            className="relative z-10 rounded-full bg-gray-50 px-3 py-1.5 font-medium text-gray-600 hover:bg-gray-100 dark:bg-gray-800/60 dark:text-gray-300 dark:hover:bg-gray-800"
                                                        >
                                                            {post.category.title}
                                                        </a>
                                                    </div>
                                                    <div className="group relative grow">
                                                        <h3 className="mt-3 text-lg/6 font-semibold text-white group-hover:text-gray-600 dark:text-white dark:group-hover:text-gray-300">
                                                            <a href={post.href}>
                                                                <span className="absolute inset-0" />
                                                                {post.title}
                                                            </a>
                                                        </h3>
                                                        <p className="mt-5 line-clamp-3 text-sm/6 text-white dark:text-gray-400">{post.description}</p>
                                                    </div>
                                                </article>
                                            ))}
                                        </div>
                                    </div>
                                    <h2 className='text-white text-xl  mt-16'>
                                        A lire <br /><small>Ouvrages des membres de l’équipe artistique et scientifique :</small>
                                    </h2>
                                    <ul className="divide-y divide-gray-100 dark:divide-white/5">
                                        {projects.map((project) => (
                                            <li key={project.id} className="flex items-center justify-between gap-x-6 py-5">
                                                <div className="min-w-0">
                                                    <div className="flex items-start gap-x-3">
                                                        <p className="text-md font-semibold text-white dark:text-white">{project.name}</p>
                                                        <p className="mt-0.5 rounded-md bg-green-50 px-1.5 py-0.5 text-xs font-medium text-green-700 inset-ring inset-ring-green-600/20 dark:bg-green-400/10 dark:text-green-400 dark:inset-ring-green-500/20">
                                                            {project.status}
                                                        </p>

                                                    </div>
                                                    <div className="mt-1 flex items-center gap-x-2 text-sm text-gray-500 dark:text-gray-400">
                                                        <p className="whitespace-nowrap">
                                                            <time dateTime={project.dueDateTime}>{project.dueDate}</time>
                                                        </p>
                                                        <svg viewBox="0 0 2 2" className="size-0.5 fill-current">
                                                            <circle r={1} cx={1} cy={1} />
                                                        </svg>
                                                        <p className="truncate">{project.createdBy}</p>
                                                    </div>
                                                </div>

                                            </li>
                                        ))}
                                    </ul>

                                    <h2 className='text-white text-xl  mt-16'>
                                        <small>A lire aussi :</small>
                                    </h2>
                                    <ul className="divide-y divide-gray-100 dark:divide-white/5">
                                        {projects2.map((project) => (
                                            <li key={project.id} className="flex items-center justify-between gap-x-6 py-5">
                                                <div className="min-w-0">
                                                    <div className="flex items-start gap-x-3">
                                                        <p className="text-md font-semibold text-white dark:text-white">{project.name}</p>
                                                        <p className="mt-0.5 rounded-md bg-green-50 px-1.5 py-0.5 text-xs font-medium text-green-700 inset-ring inset-ring-green-600/20 dark:bg-green-400/10 dark:text-green-400 dark:inset-ring-green-500/20">
                                                            {project.status}
                                                        </p>

                                                    </div>
                                                    <div className="mt-1 flex items-center gap-x-2 text-sm text-gray-500 dark:text-gray-400">
                                                        <p className="whitespace-nowrap">
                                                            <time dateTime={project.dueDateTime}>{project.dueDate}</time>
                                                        </p>
                                                        <svg viewBox="0 0 2 2" className="size-0.5 fill-current">
                                                            <circle r={1} cx={1} cy={1} />
                                                        </svg>
                                                        <p className="truncate">{project.createdBy}</p>
                                                    </div>
                                                </div>

                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
